import { SETUP_FORM_FIELDS } from '_views/setup-form/utils/steps'

import Model from './model'

class Form extends Model({
  ...Object.values(SETUP_FORM_FIELDS).reduce((acc, current) => ({ ...acc, [current]: '' }), {}),
}) {}

export { Form as default }
